import React from "react";
import PageTemplate from "../../components/PageTemplate";
import SettingsBody from "../../components/Settings/AccountSettingsBody";
import { AccountSettingsContext } from "../../context/AccountSettingsState";
import AccountSettingsMobileHeader from "../../components/Settings/AccountSettingsMobileHeader";

const Settings = () => {
  return (
    <AccountSettingsContext>
      <PageTemplate
        title="Settings"
        mobileHeader={<AccountSettingsMobileHeader />}
        sidebarTitle="The Fine Print"
        sidebarSubtitle={"Don't sweat the small stuff; just manage it."}
      >
        <SettingsBody />
      </PageTemplate>
    </AccountSettingsContext>
  );
};

export default Settings;
